// extracted by mini-css-extract-plugin
export default {"page":"gma-z","cartModal":"hma-z","checkout":"ima-z","placeholder":"jma-z","account":"kma-z"};